var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen bg-gray-50 pb-28",attrs:{"dir":"rtl"}},[_c('BottomNav',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('Chats')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }